import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  private snackBar = inject(MatSnackBar);

  readonly #CLOSE = 'Close';
  readonly #SNACKBAR_DURATION = 3000;

  displayMessage(message: string): void {
    this.snackBar.open(message, this.#CLOSE, {
      duration: this.#SNACKBAR_DURATION,
    });
  }
}
